import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

const httpHeadersToJSON = (headers) => {
    if (!headers || !headers.keys || typeof headers.keys !== 'function' || !headers.keys().length) {
        return {};
    }
    return headers.keys().reduce((acc, val) => {
        return {
            ...acc,
            [val]: headers.get(val),
        };
    }, {});
};
class HttpErrorInterceptor {
    intercept(request, next) {
        return next
            .handle(request)
            .pipe(catchError((error) => {
            console.error(`
Error fetching.

REQUEST
URL: ${request.urlWithParams}
Method: ${request.method}
Headers: ${JSON.stringify(httpHeadersToJSON(request.headers))}
Payload: ${JSON.stringify(request.body)}

RESPONSE
Status: ${error.status}
Status text: ${error.statusText}
Message: ${error.message}
Headers: ${JSON.stringify(httpHeadersToJSON(error.headers))}
Payload: ${JSON.stringify(error.error)}`);
            return throwError(() => error);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.5", ngImport: i0, type: HttpErrorInterceptor, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.5", ngImport: i0, type: HttpErrorInterceptor, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.5", ngImport: i0, type: HttpErrorInterceptor, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { HttpErrorInterceptor };
